import { Typography } from "../../mui";

const styles = {
  h1: {
    fontFamily: "Roboto",
    fontWeight: 500,
    fontSize: "54px",
    lineHeight: "116.7%",
    letterSpacing: "-1.5px",
    color: "rgba(0, 0, 0, 0.6)",
  },
  h3: {
    fontFamily: "Helvetica",
    fontWeight: 300,
    fontSize: "3rem",
    lineHeight: 1.167,
    letterSpacing: "-0.01562em",
  },
};

const HeaderText = (props) => {
  return <Typography variant="h1">{props.children}</Typography>;
};

const SubText = (props) => {
  return <Typography variant="h1">{props.children}</Typography>;
};

export { HeaderText, SubText };
